<template>
  <div class="content">
    <div class="container-fluid">

      Marketing - Coming Soon
      <hr>
      

      <!-- Show Dashboard -->

      <div class="row" v-if="ShowDashboard">

   <!--          <div class="col-xl-6 col-md-6">
            


                <div class="row">

                  <div class="col-md-6">
                    <label>From</label>
                    <input type="date" class="form-control" id="exampleInputPassword1" v-model="fromDate" @change="Filter()">
                  </div>

                  <div class="col-md-6">
                    <label>To</label>
                    <input type="date" class="form-control" id="exampleInputPassword1" v-model="toDate" @change="Filter()">
                  </div>


                </div>



            </div> -->

      <!--       <div class="col-xl-6 col-md-6">
              <div class="row stats text-center">

                <div class="col-3">
                  <h1 class="text-primary stats123">{{Stats.Total}}</h1>
                  <p class="Label">Total Visitors</p>                  
                </div>

                <div class="col-3">
                  <h1 class="text-warning stats123">{{Stats.Pending}}</h1>
                  <p class="Label">Pending Approval</p>                  
                </div>

                <div class="col-3">
                  <h1 class="text-success stats123">{{Stats.CheckedIn}}</h1>
                  <p class="Label">Checked In</p>                  
                </div>

                <div class="col-3">
                  <h1 class="text-danger stats123">{{Stats.CheckedOut}}</h1>
                  <p class="Label">Checked Out</p>                  
                </div>

              </div>
            </div> -->

      </div>



      </div>


  
      </div>


    </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import { globalStore } from '../main.js';
  import { db } from '../main.js';
  import $ from 'jquery';
  import moment from 'moment';
  import axios from 'axios';
  import swal from 'sweetalert';

  // Require needed datatables modules
  require('datatables.net')

  // const tableColumns = ['Id', 'Name', 'Salary', 'Country', 'City']

  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard
    },
    data () {
      return {
        fromDate: '',
        toDate: '',
        ShowToday: true,
        ShowDashboard: true, 
        ShowCheckList: true,
        CompanyId: '',
        MyVisitors: [],
        Stats: {
          Total: 0,
          Pending: 0,
          CheckedIn: 0,
          CheckedOut: 0,
        },
        columns: [
          'Date',
          'Photo',
          'Name',
          'Mobile',
          'Email',
          'Location',
          'Host',
          'Purpose',
          'Type',
          'Check In Time',
          'Check Out Time',
          'Status',
          'Approved On'
        ],
        tableData: {
          data: [
            {title: "Download & print your unique QR Code. Visitors will scan this from their phone for web Check In. The best part is they don't need to have the Visity app installed. Go to Side Menu > Profile and download it now.", checked: false},
            {title: "Go to Side Menu > My Team > Add your team members.", checked: false},
            {title: 'To leverage the full power of Visity, check out the "How it works?" section .', checked: false},
          ]
        }
      }
    },
    beforeMount(){
      console.log("beforeMount");
    },
    mounted(){
      console.log("Mounted");

      this.CompanyId = globalStore.AdminId
      console.log("CompanyId: "+this.CompanyId);

      this.FirstLoad();

    },
    methods:{
      Toggle(){

        if(this.ShowToday){
          this.ShowToday = false;
          this.GetThisWeek();
        }else{
          this.ShowToday = true;
          this.GetToday();
        }

      },
      FirstLoad(){

        console.log("---- First Load ----");

        this.fromDate =  moment().startOf('isoWeek').format('YYYY-MM-DD');
        this.toDate = moment().endOf('isoWeek').format('YYYY-MM-DD');

        console.log("From: "+this.fromDate);
        console.log("To: "+this.toDate);

        this.GetMyVisitors(this.toDate, this.fromDate);

      },
      Filter(){

        this.destroyDataTable();

        var from = moment(this.fromDate).format('YYYY-MM-DD');
        var to = moment(this.toDate).format('YYYY-MM-DD');

        console.log("From: "+from);
        console.log("To: "+to);

        this.GetMyVisitors(to, from);

      },
      GetMyVisitors(to, from){

      console.log("Getting My Visitors...");

      //-------- call to fetch all data -------
      this.MyVisitors = []

      console.log("CompanyId: "+this.CompanyId);

      db.collection('MyVisitors')
        .where("HostCompanyId", "==", this.CompanyId)
        .where("CheckInTime", "<", to)
        .where("CheckInTime", ">", from)
        .get()
        .then((snap) => {

        this.MyVisitors = []
          // let data = snap.docs;
          // console.log(data);
          snap.docs.forEach(doc => {
            console.log("Doc id is: " + doc.id);
            console.log("Name is: " + doc.data().FirstName);
            // console.log("Status: " + doc.data().Status);

                    var email = "";

                    if(doc.data().Email){
                      email = doc.data().Email;
                    }


                    this.MyVisitors.push({id: doc.id,
                      VisitorPhoto: doc.data().PhotoURL,
                      VisitorFirstName: doc.data().FirstName,
                      VisitorLastName: doc.data().LastName,
                      VisitorMobile: doc.data().Mobile,
                      VisitorEmail: email,
                      HostLocation: doc.data().HostLocation,
                      UserId: doc.data().UserId,
                      HostId: doc.data().HostId,
                      Type: doc.data().Type,
                      HostMobile: doc.data().HostMobile,
                      HostFirstName: doc.data().HostFirstName,
                      HostLastName: doc.data().HostLastName,
                      HostCompanyName: doc.data().HostCompanyName,
                      MeetingOn: doc.data().InviteDate+'|'+doc.data().InviteTime,
                      InviteDate: doc.data().InviteDate,
                      InviteTime: doc.data().InviteTime,
                      Status: doc.data().Status,
                      CheckInTime: doc.data().CheckInTime,
                      CheckOutTime: doc.data().CheckOutTime,
                      ApprovedOn: doc.data().ApprovedOn,
                      VisitPurpose: doc.data().VisitPurpose,
                      Date: doc.data().Date,
                      CreatedOn: doc.data().CreatedOn});
                  });

                  console.log('All data fetch from MyVisitors - Success');

                  setTimeout(()=>{
                    console.log("Total Visitors: "+this.MyVisitors.length);
                    this.CalculateStats();
                    this.initializeDataTable();
                  },500)



          });

        // .catch((e) => {
        //   console.log('Error:', (e));
        // });

    },
    CalculateStats(){

        this.Total = 0;
        this.Pending = 0;
        this.countIn = 0;
        this.countOut = 0;

        this.Stats.Total = 0;
        this.Stats.Pending = 0;
        this.Stats.CheckedIn = 0;
        this.Stats.CheckedOut = 0;

      this.MyVisitors.map((val)=>{

        this.Stats.Total++;

        if(val.Status == 'Pending'){
          this.Stats.Pending++;
        }else if(val.Status == 'CheckedIn'){
          this.Stats.CheckedIn++;
        }else if(val.Status == 'CheckedOut'){
          this.Stats.CheckedOut++;
        }

      })

    },
    showPhoto(info){

      console.log('hello');
      Swal.fire({
        imageUrl: info.VisitorPhoto,
        // imageHeight: 1500,
        imageAlt: 'Visity'
        });
      },
      Hide(){
        console.log("Hide");
        this.ShowCheckList = false;
        this.ShowDashboard = true;
      },
      GetMyTeam(){

        db.collection("MyTeam")
          .where('CompanyId','==',this.CompanyId)
          .get()
          .then((snap) => {
            console.log("MyTeam Total: "+snap.docs.length)
          })
          .catch((e) => {
            console.log('Error Getting MyTeam:', (e));
          });

      },
    notifyVue (verticalAlign, horizontalAlign, msg, type, icon) {
        // const color = Math.floor((Math.random() * 4) + 1)
        this.$notifications.notify(
          {
            message: msg,
            icon: icon,
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type: type
          })
    }, 
    destroyDataTable(){

        this.MyVisitors = [];

        var table = $('#Visitors').DataTable();             
        table.destroy();  

    },
      initializeDataTable(){
        console.log("initializeDataTable")

        setTimeout(() => {
          this.$nextTick(() => {

            $("#Visitors").DataTable({
              // sDom: '<"top"fi>rt<"Bbottom"Bl><"clear">',
              dom: 'frBtip',
              fixedHeader: true,
              buttons: [
                {
                  extend: "csvHtml5",
                  text: "Download",
                  title: "Visitors"
                },
              ]
            });

          });
        }, 1000);


      },   
    UpdateStatuss(info){

      console.log("ChangeStatus")

        swal({
          title: "Are you sure you want to update the status?",
          text: "",
          icon: "warning",
          buttons: true,
          dangerMode: false,
        })
        .then((willDelete) => {
          if (willDelete) {

            console.log("id: "+info.id);
            console.log("Current Status: "+info.Status);

            if(info.Status == 'CheckedIn'){
              this.UpdateToCheckedOut(info.id, info);
            }else{
              this.UpdateToCheckedIn(info.id);
            }


          } else {

          }
        });


    },
    ApproveVisitor2(info){

        swal({
          title: "Are you sure you want to approve visitor?",
          text: "",
          icon: "warning",
          buttons: true,
          dangerMode: false,
        })
        .then((res) => {
          if (res) {

            console.log("id: "+info.id);
            console.log("Current Status: "+info.Status);

            db.collection("MyVisitors")
                  .doc(info.id)
                  .update({Status: "CheckedIn", ApprovedOn: moment().format()})
                  .then(() => {

                    console.log('Success');
                    location.reload();


                  })
                  .catch(error => {
                    console.error("Error removing document: ", error);
                  });            

          } else {

          }
        });

    },
    UpdateToCheckedOut(id, info){
      console.log("Update Status to CheckedOut");
      console.log("UserId: "+info.UserId);
      console.log("Object: "+JSON.stringify(info, null, 2));
        console.log(globalStore.CompanyName);



            db.collection("MyVisitors")
                  .doc(id)
                  .update({Status: "CheckedOut", CheckOutTime: moment().format()})
                  .then(() => {

                    console.log('Success');
                    // this.SendPush(info)
                    this.SendPushCheckOut(info);

                  })
                  .catch(error => {
                    console.error("Error removing document: ", error);
                  });


    },
    UpdateToCheckedIn(id){
      console.log("Update Status to CheckedIn");

            db.collection("MyVisitors")
                  .doc(id)
                  .update({Status: "CheckedIn"})
                  .then(() => {

                    console.log('Success');
                    location.reload();

                  })
                  .catch(error => {
                    console.error("Error removing document: ", error);
                  });

    },
    SendPushCheckOut(info){

        console.log("Send Push...");
        console.log("UserId: "+info.UserId);

        db.collection('Users')
          .doc(info.UserId)
          .get()
          .then((doc) => {

            if(doc.exists){
              // console.log(doc.data());
              console.log("Token: "+doc.data().Token);

              console.log("Visitor Name: "+info.VisitorFirstName+"" +info.VisitorLastName);
              console.log("CompanyName: "+globalStore.CompanyName);
              console.log("Check In Time: "+moment(info.CheckInTime).format('h:mm a'));

              var data = {
                Token: doc.data().Token,
                Title: "Hi "+info.VisitorFirstName,
                Body: "Thank you for visiting "+globalStore.CompanyName+".",
              };

              console.log("Push Payload: "+JSON.stringify(data, null, 2))

                axios.post("https://us-central1-visity-usa.cloudfunctions.net/widgets/send-push", data).then((res) => {
                // axios.post("http://localhost:5001/visity-fcbd6/us-central1/widgets", info).then((res) => {
                  console.log(res);
                    location.reload();
                  
                }).catch((e) => {
                  console.log(e);
                });

            }
          })
          .catch((e) => {
            console.log('Error:', (e));
          });        

    },
    },

  }
</script>

<style scoped="">

  .excelButton{
    background: green;
    border-radius: 10px;
  }

  .stats{
    border: 1px solid #DCDCDC;
    border-radius: 0.5em;
  }

  .Label{
    color: #707070;
  }

  .table1{
    margin-top: 1em;
  }

.dt-buttons.dt-button.buttons-csv.buttons-html5{
  margin-left: 20em;
  background: #00b33c;
  border: 1px solid #00b33c;
  color: #ffffff;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  padding-left: 1em;
  padding-right: 1em;
  border-radius: 0.5em;
}

#Visitors_filter.dataTables_filter{
    /*margin-left: 5em;*/
  }

  .nc-check-2{
    color: green;
  }

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}


.fa-check{
  color: #00b300;
}

.fa-square-o{
  color: #007bff;
}

.fa-exclamation{
  color: red;
}

.btn{
  width: 10em;
  font-size: 1em;
  font-weight: bold;
}

.stats123{
  font-weight: 350;
}


/*Show Todays*/

.Today{
  margin-left: 1em;
  color: #ffffff;
  border: 1px solid #007bff;
  background-color: #007bff;
  padding-right: 1em;
  padding-left: 1em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  font-size: 1em;
  font-weight: 400;
  width: 10em;
}

.ThisWeek{
  margin-left: 1em;
  /*color: #ffffff;*/
  color: #007bff;
  border: 1px solid #007bff;
  background-color: #ffffff;
  padding-right: 1em;
  padding-left: 1em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  font-size: 1em;
  font-weight: 400;
  width: 10em;
}

.ThisWeek:hover{
  cursor: pointer;
  margin-left: 1em;
  color: #ffffff;
  border: 1px solid #007bff;
  background-color: #007bff;
  padding-right: 1em;
  padding-left: 1em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  font-size: 1em;
  font-weight: 400;
  width: 10em;
}



/*Show This Week*/

.Today2{
  margin-left: 1em;
  color: #007bff;
  border: 1px solid #007bff;
  background-color: #ffffff;
  padding-right: 1em;
  padding-left: 1em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  font-size: 1em;
  font-weight: 400;
  width: 10em;
}

.ThisWeek2{
  margin-left: 1em;
  /*color: #ffffff;*/
  color: #ffffff;
  border: 1px solid #007bff;
  background-color: #007bff;
  padding-right: 1em;
  padding-left: 1em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  font-size: 1em;
  font-weight: 400;
  width: 10em;
}

.Today2:hover{
  cursor: pointer;
  margin-left: 1em;
  color: #ffffff;
  border: 1px solid #007bff;
  background-color: #007bff;
  padding-right: 1em;
  padding-left: 1em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  font-size: 1em;
  font-weight: 400;
  width: 10em;
}

</style>
